import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Button from '../../../component/ui/Button';
import './Product.scss';
import sortbydot from '../../../assets/image/sort_by_group.svg';
import { useDispatch, useSelector } from 'react-redux';
import { change_status } from '../../../store/action/product';
import { toast } from 'react-toastify';
import { group_update, product_group_list } from '../../../store/action/group';
import Modal from '../../../component/modal/Modal';
import AddToGroupModal from './AddToGroupModal';
import { ObjectCreate } from '../../../utils/utility';
import InputField from '../../../component/form/FormInput';
import { status_dropdown } from '../../../utils/dropsdown';
import InputSelect from '../../../component/inputSelect/InputSelect';
import { formatErrors, hasPermission } from '../../../utils/controller';
import { ExportTable } from '../../../store/action/export/Export';
import BulkImport from './BulkImport';
import Pagination from '../../../component/pagination';
import arrowDownBlackIcon from '../../../assets/image/arrow_down_dark.svg';
import ImageRenderer from '../../../component/imageRenderer/imageRnder';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import AdvanceFilter from '../../../component/Filter/AdvanceFilter';
import advanceFilterOptions from '../../../component/Filter/advanceFilterOptions';
import clearAllFilter from '../../../assets/image/clearAllFilter.svg';
import addFilter from '../../../assets/image/AddFilter.svg';
import advanceFilterIcon from '../../../assets/image/advanceFilter.svg';
import {
	clearAdvanceFilter,
	removeSelectedInput,
	setAdvanceFilter,
	setAdvanceFilterPage,
	setAdvanceFilterTotalPage,
	setSelectedInput,
	setSelectedInputData,
	setSelectedInputValue,
} from '../../../store/action/advanceFilter';
import AdvanceFilterSelectInput from '../../../component/Filter/AdvanceFilterSelectInput';
import { getFiltersParams } from '../../../helper';
import Table from '../../../component/table/Table';
import { getProductList, getProducts } from '../../../services/products';

const Product = () => {
	const param = useParams();
	const productId = param?.id;
	const GroupID = param?.id;
	const navigateRouter = (path) => {
		navigate(path);
	};
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(0);
	const [bulkAction, setBulkAction] = useState([]);
	const [open, setIsOpen] = useState(false);
	const [buklImport, setIsbuklImport] = useState(false);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [tableData, setTableData] = useState([]);
	const [groupOption, setGroupOptions] = useState([]);
	const [stateCondition, setStateCondition] = useState('');
	const [groupName, setgroupName] = useState('');
	const [groupStatus, setgroupStatus] = useState('');
	const [error, setError] = useState({});
	const [headerDropDown, setHeaderDropDown] = useState('All Products');
	const [sortParam, setSortParam] = useState('');
	const [showOptions, setShowOptions] = useState('');
	const [sortDirection, setSortDirection] = useState({});
	const [productList, setProductList] = useState([]);
	const [loading, setLoader] = useState(false);
	const [isAdvanceFilterOpen, setIsAdvanceFilterOpen] = useState(false);
	const productgroupData = useSelector((state) => state?.productGroup?.data?.data?.productGroups);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const suburl = localStorage.getItem('suburl');
	const [params, setParams] = useState({
		page: 1,
		pageSize: 20,
		filters: {},
		orderBy: 'created_at',
		sortBy: 'desc',
	});
	const {
		page: advanceFilterPage,
		totalPages: advanceFilterTotalPages,
		pageSize: advanceFilterPageSize,
		orderBy: advanceFilterOrderby,
		sortBy: advanceFilterSortBy,
		selectedInputs,
		isAdvanceFilterApplied,
	} = useSelector((state) => state.advanceFilter);

	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};

	const ProductTableColumn = [
		{
			field: ' ',
			headerClass: 'HeaderBg',
			checkboxSelection: true,
			headerCheckboxSelection: true,
			minWidth: 50,
			maxWidth: 50,
			lockPosition: true,
		},
		{
			field: 'IMAGE',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 50,
			maxWidth: 80,
			flex: 1,
			cellRenderer: ImageRenderer,
		},

		{
			field: 'PRODUCT CODE',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 150,
			flex: 1,
			cellRenderer: (params) => {
				const data = JSON.parse(params.data['product_code']);
				return (
					<p style={{ alignItems: 'center' }}>
						{data?.code}
						{data?.status === 0 && (
							<span
								style={{
									backgroundColor: '#718096',
									color: 'white',
									borderRadius: '20px',
									padding: '2px 10px',
									paddingBottom: '3px',
									marginLeft: '10px',
									fontSize: '11px',
								}}
							>
								Inactive
							</span>
						)}
					</p>
				);
			},
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortProduct({ sortBy: 'asc', orderBy: 'product_code' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								PRODUCT CODE
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.product_code]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'PRODUCT NAME',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortProduct({ sortBy: 'asc', orderBy: 'product_name' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								PRODUCT NAME
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.product_name]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'STOCK IN HAND',
			headerClass: 'HeaderBg right-align',
			suppressSizeToFit: true,
			minWidth: 150,
			flex: 1,
			cellClass: 'right-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'end',
						}}
						onClick={() => sortProduct({ sortBy: 'asc', orderBy: 'stock_in_hand' })}
					>
						<div>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								STOCK IN HAND
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.stock_in_hand]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'REORDER LEVEL',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 150,
			flex: 1,
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortProduct({ sortBy: 'asc', orderBy: 'reorder_level' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								REORDER LEVEL
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.reorder_level]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		...(params.filters.sales_product || params.filters.purchase_product
			? [
					{
						field: 'AMOUNT',
						headerClass: 'HeaderBg',
						suppressSizeToFit: true,
						minWidth: 150,
						flex: 1,
						headerComponent: () => {
							return (
								<div
									style={{
										width: '100%',
										paddingTop: '10px',
										cursor: 'pointer',
									}}
									onClick={() => sortProduct({ sortBy: 'asc', orderBy: 'amount' })}
								>
									<div
										style={{
											width: '55px',
										}}
									>
										<p
											style={{
												display: 'flex',
												alignItems: 'center',
												color: 'black',
											}}
										>
											AMOUNT
											<span
												style={{
													fontSize: '18px',
													fontWeight: '800',
												}}
											>
												{sortIconMap[sortDirection?.amount]}
											</span>
										</p>
									</div>
								</div>
							);
						},
					},
				]
			: []),
	];

	async function handleOnFocusSelectedFilterInput(key) {
		let selectInputData = [];
		if (key !== 'status') {
			const data = await getProductList({ filterBy: key });

			selectInputData = data?.productWithStockCount?.map((po) => ({
				key: po[key],
				value: po[key],
			}));
		} else {
			selectInputData = [
				{ key: 'active_products', value: 'Active Products' },
				{ key: 'inactive_products', value: 'Inactive Products' },
				{ key: 'low_stock_products', value: 'Low Stock Products' },
				// { key: 'sales_product', value: 'Sales' },
				// { key: 'purchase_product', value: 'Purchase' },
			];
		}
		dispatch(setSelectedInputData({ key, data: selectInputData }));
	}

	async function searchSelectedInputItems(key, value) {
		try {
			let optionsList;
			if (key === 'status') {
				optionsList = [
					{ key: 'active_products', value: 'Active Products' },
					{ key: 'inactive_products', value: 'Inactive Products' },
					{ key: 'low_stock_products', value: 'Low Stock Products' },
				];
			} else {
				const data = await getProductList({ filterBy: key, filterValue: value });
				optionsList = data?.productWithStockCount?.map((po) => ({
					key: po[key],
					value: po[key],
				}));
			}

			dispatch(setSelectedInputData({ key, data: optionsList }));
		} catch (error) {
			toast.error(error?.message || 'Something went wrong!');
		}
	}

	async function handleApplyFilters(params) {
		try {
			if (Object.keys(params).length === 0) return;
			if (params.status) {
				setHeaderDropDown(params.status);
				const statusMap = {
					'Inactive Products': 0,
					'Active Products': 1,
				};
				if (params.status === 'Low Stock Products') {
					params['low_stock_products'] = true;
					delete params.status;
				} else if (params.status === 'Sales') {
					params['sales_product'] = true;
					delete params.status;
				} else if (params.status === 'Purchase') {
					params['purchase_product'] = true;
					delete params.status;
				} else {
					params.status = statusMap[params.status];
				}
			}
			const { products, totalPages } = await getProducts({
				filters: params,
				orderBy: advanceFilterOrderby,
				sortBy: advanceFilterSortBy,
				page: advanceFilterPage,
				pageSize: advanceFilterPageSize,
			});
			dispatch(setAdvanceFilterTotalPage({ totalPages }));
			setTableData(mappedTableData(products));
			setIsAdvanceFilterOpen(false);
			setTotalPages(totalPages);
		} catch (error) {
			toast.error(error?.message || 'Something went wrong! Try again.');
		}
	}

	function mappedTableData(data) {
		return (
			data?.map((ele) => {
				return {
					id: ele.product_id,
					'PRODUCT NAME': ele?.product_name,
					product_code: JSON.stringify({ code: ele?.product_code, status: ele?.status }),
					'STOCK IN HAND': ele?.stock_in_hand || 0,
					'REORDER LEVEL': 'NA',
					Status: 'Enable',
					IMAGE: ele?.image,
					...(params.filters.sales_product || params.filters.purchase_product
						? { AMOUNT: Number(ele?.amount).toFixed(2) }
						: {}),
				};
			}) ?? []
		);
	}

	const getAllProduct = async () => {
		try {
			setLoader(true);
			const { products, totalPages } = await getProducts(params);
			const mappedData = mappedTableData(products);
			setTableData(mappedData);
			setProductList(products);
			setTotalPages(totalPages);
		} catch (error) {
		} finally {
			setLoader(false);
		}
	};

	const handlePageChange = (page) => {
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilterPage({ page: page }));
		} else {
			setParams((prev) => ({
				...prev,
				page: page,
			}));
			setCurrentPage(page);
		}
	};

	const filterProduct = (param, value, dropDownData) => {
		if (dropDownData === 'Sales' || dropDownData === 'Purchase') {
			dispatch(clearAdvanceFilter());
			setParams((prev) => ({
				...prev,
				...param,
			}));
			setStateCondition(value);
			setHeaderDropDown(dropDownData);
			setCurrentPage(1);
		} else {
			setParams((prev) => ({
				...prev,
				filters: {},
			}));
			if (dropDownData === 'All Products') {
				dispatch(clearAdvanceFilter());

				setHeaderDropDown('All Products');
				return;
			}
			setHeaderDropDown(dropDownData);
			const updatedSelectedInput = selectedInputs.map((input) => {
				if (input.key === 'status') {
					return {
						...input,
						value: dropDownData,
					};
				}
				return input;
			});
			dispatch(setSelectedInput({ key: 'status', label: 'Status' }));
			dispatch(setSelectedInputValue({ key: 'status', value: dropDownData }));
			dispatch(setAdvanceFilter({ isAdvanceFilterApplied: true }));
			var selectInputData = [
				{ key: 'active_products', value: 'Active Products' },
				{ key: 'inactive_products', value: 'Inactive Products' },
				{ key: 'low_stock_products', value: 'Low Stock Products' },
			];
			dispatch(setSelectedInputData({ key: 'status', data: selectInputData }));
			const params = getFiltersParams(updatedSelectedInput);
			handleApplyFilters(params);
		}
	};

	const sortProduct = async (param) => {
		const newDirection = sortDirection[param.orderBy] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.orderBy]: newDirection });
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilter({ orderBy: param.orderBy, sortBy: newDirection }));
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			setParams((prev) => ({
				...prev,
				orderBy: param.orderBy,
				sortBy: newDirection,
			}));
		}
	};

	const markAsActive = () => {
		let formbody = {
			product_ids: bulkAction,
			status: 1,
		};
		change_status(formbody).then((res) => {
			if (res?.success) {
				toast.success(res?.message);
				getAllProduct();
				setBulkAction([]);
			} else {
				toast.error(res?.message);
			}
		});
	};

	const markAsInactive = () => {
		let formbody = {
			product_ids: bulkAction,
			status: 0,
		};
		change_status(formbody).then((res) => {
			if (res?.success) {
				toast.success(res?.message);
				getAllProduct();
				setBulkAction([]);
			} else {
				toast.error(res?.message);
			}
		});
	};

	const handlegroupUpdate = () => {
		let body = {
			name: groupName,
			status: Number(groupStatus),
		};
		dispatch(group_update(GroupID, body)).then((res) => {
			if (res?.success) {
				toast.success(res?.message);
			} else {
				toast.error(res?.message);
				let err = formatErrors(res?.data?.message);
				setError(err);
			}
		});
	};

	const exportData = (param) => {
		ExportTable(param);
	};

	const onRowClick = (id) => {
		if (id && hasPermission('inventory.products.view', user?.role?.role_permissions)) {
			navigate(`/user/${suburl}/product-create/${id}`);
		}
	};

	useEffect(() => {
		if (productgroupData) {
			const result = ObjectCreate({
				data: productgroupData,
				key: 'product_group_id',
				value: 'name',
			});
			const groupName = productgroupData?.filter((ele) => {
				return ele?.product_group_id === Number(productId);
			});
			setgroupName(groupName?.[0]?.name);
			setgroupStatus(`${groupName?.[0]?.status}`);
			setGroupOptions(result);
		}
	}, [productgroupData]);

	const groupList = () => {
		let param = `page=${1}&pageSize=200`;
		product_group_list(param);
	};

	useEffect(() => {
		groupList();
	}, []);

	useEffect(() => {
		if (isAdvanceFilterApplied) {
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			getAllProduct();
		}
	}, [productId, sortParam, currentPage, advanceFilterPage, isAdvanceFilterApplied, params]);

	return (
		<div>
			{bulkAction && bulkAction.length > 0 ? (
				<div className="product-pg-header">
					<div className="dropdown text-end">
						<p className="d-block link-dark text-decoration-none">Bulk Actions</p>
					</div>
					<div className="add-product-button">
						{stateCondition !== 'active' && (
							<Button
								type="button"
								button="Mark as Active"
								className="mt-0 px-4 btn-gray"
								onClick={markAsActive}
							/>
						)}
						{stateCondition !== 'inactive' && (
							<Button
								type="button"
								button="Mark as Inactive"
								className="mt-0 px-4 btn-gray"
								onClick={markAsInactive}
							/>
						)}
						<div className="dropdown-container">
							<div
								className="select-box text-dark"
								style={{ backgroundColor: '#daddec' }}
								onClick={() => setShowOptions(!showOptions)}
							>
								<div className="d-flex flex-row align-items-center gap-4">
									<div className="fs-5 font-bold">{'New Transaction'}</div>
									<img
										src={arrowDownBlackIcon}
										alt="arrow"
										width={10}
										height={10}
									/>
								</div>
							</div>

							{showOptions && (
								<ul
									className="options-list"
									style={{ zIndex: 40, width: '145px' }}
								>
									{['Purchase Order', 'Sales Invoice'].map((label, idx) => (
										<li
											key={idx}
											onClick={() => {
												if (label === 'Purchase Order') {
													const data = productList
														?.filter((item) => bulkAction.includes(item.product_id))
														.map((item) => {
															return {
																id: item.product_id,
																packaging: item.packaging_name,
															};
														});
													console.log(data);
													navigate(`/user/${suburl}/purchases-order-create`, {
														state: { products: data },
													});
												} else if (label === 'Sales Invoice') {
													const data = productList
														?.filter((item) => bulkAction.includes(item.product_id))
														.map((item) => {
															return {
																id: item.product_id,
																tax1: item.tax_1,
																tax2: item.tax_2,
															};
														});
													navigate(`/user/${suburl}/invoices-create`, {
														state: { products: data },
													});
												}
											}}
										>
											<div className="text-dark">{label}</div>
										</li>
									))}
								</ul>
							)}
						</div>
					</div>
				</div>
			) : (
				<div className="product-pg-header">
					{productId ? (
						<div className="dropdown text-end">
							<a className="d-block link-dark text-decoration-none">
								<p>Group Details</p>
							</a>
						</div>
					) : (
						<div
							className="dropdown text-end d-flex"
							style={{ gap: '12px', alignItems: 'center', display: 'flex' }}
						>
							<a
								className="d-block link-dark text-decoration-none dropdown-toggle"
								id="dropdownUser1"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								<p>{headerDropDown}</p>
							</a>
							<ul
								className="dropdown-menu font-14"
								aria-labelledby="dropdownUser1"
								style={{ minWidth: '240px' }}
							>
								<li>
									<a
										className="dropdown-item"
										onClick={() => filterProduct({ filters: {} }, '', 'All Products')}
									>
										All Products
									</a>
								</li>
								<li>
									<a
										className="dropdown-item"
										onClick={() =>
											filterProduct({ filters: { status: 1 } }, 'active', 'Active Products')
										}
									>
										Active Products
									</a>
								</li>

								<li>
									<a
										className="dropdown-item"
										onClick={() =>
											filterProduct({ filters: { status: 0 } }, 'inactive', 'Inactive Products')
										}
									>
										Inactive Products
									</a>
								</li>

								<li>
									<a
										className="dropdown-item"
										onClick={() =>
											filterProduct(
												{ filters: { low_stock_product: true } },
												'',
												'Low Stock Products',
											)
										}
									>
										Low Stock Products
									</a>
								</li>
								<li>
									<a
										className="dropdown-item"
										onClick={() => filterProduct({ filters: { sales_product: true } }, '', 'Sales')}
									>
										Sales
									</a>
								</li>
								<li>
									<a
										className="dropdown-item"
										onClick={() =>
											filterProduct({ filters: { purchase_product: true } }, '', 'Purchase')
										}
									>
										Purchase
									</a>
								</li>
							</ul>
							<div>
								{isAdvanceFilterApplied ? (
									<div>
										<button
											onClick={() => {
												dispatch(clearAdvanceFilter());
												setHeaderDropDown('All Products');
											}}
											style={{
												background: 'transparent',
												color: '#FF0000',
												fontSize: '14px',
												cursor: 'pointer',
												fontWeight: '600',
												lineHeight: '24px',
											}}
										>
											<img
												src={clearAllFilter}
												alt=""
												style={{ width: '18px', height: '18px', marginRight: '8px' }}
											/>
											Clear All Filters
										</button>
									</div>
								) : (
									<button
										onClick={() => setIsAdvanceFilterOpen(true)}
										style={{
											color: '#2E63F6',
											background: 'transparent',
											fontSize: '14px',
											cursor: 'pointer',
											fontWeight: '600',
											lineHeight: '24px',
										}}
									>
										<img
											src={advanceFilterIcon}
											alt=""
											style={{ width: '18px', height: '18px', marginRight: '8px' }}
										/>
										Advanced Filters
									</button>
								)}
							</div>
						</div>
					)}
					<div className="d-flex align-items-center">
						{productId ? (
							<div className="add-product-button">
								<Button
									type="button"
									className="btn-primary mt-0 px-4"
									button="Save"
									disabled={
										!hasPermission('inventory.products.create', user?.role?.role_permissions)
									}
									onClick={handlegroupUpdate}
								/>
								<Button
									type="button"
									className="mt-0 btn-danger add-pro"
									button=""
									close
									onClick={() => navigateRouter(-1)}
								/>
							</div>
						) : (
							<Button
								type="button"
								button="Add New"
								disabled={!hasPermission('inventory.products.create', user?.role?.role_permissions)}
								className="mt-0 px-4 btn-primary"
								onClick={() => navigateRouter(`/user/${suburl}/product-create`)}
								add
							/>
						)}
						{!productId && (
							<div className="dropdown text-end ms-3">
								<a
									className="d-block link-dark text-decoration-none"
									id="dropdownUser1"
									data-bs-toggle="dropdown"
									aria-expanded="false"
								>
									<img src={sortbydot} />
								</a>
								<ul
									className="dropdown-menu font-14"
									aria-labelledby="dropdownUser1"
									style={{ minWidth: '240px' }}
								>
									<li>
										<a className="dropdown-item sortBy">Sort by</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortProduct({ sortBy: 'asc', orderBy: 'created_at' })}
										>
											Created Time
											<span>{sortIconMap[sortDirection?.created_at]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortProduct({ sortBy: 'asc', orderBy: 'product_name' })}
										>
											Name
											<span>{sortIconMap[sortDirection?.product_name]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortProduct({ sortBy: 'asc', orderBy: 'product_code' })}
										>
											Product Code
											<span>{sortIconMap[sortDirection?.product_code]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortProduct({ sortBy: 'asc', orderBy: 'stock_in_hand' })}
										>
											Stock on Hand
											<span>{sortIconMap[sortDirection?.stock_in_hand]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortProduct({ sortBy: 'asc', orderBy: 'updated_at' })}
										>
											Last Modified Time
											<span>{sortIconMap[sortDirection?.updated_at]}</span>
										</a>
									</li>
									<hr />
									<li>
										<a
											className={`dropdown-item ${!hasPermission('inventory.products.import', user?.role?.role_permissions) ? 'disabled' : ''}`}
											onClick={() => setIsbuklImport(true)}
										>
											Import Product
										</a>
									</li>
									<li>
										<a
											className={`dropdown-item ${!hasPermission('inventory.products.export', user?.role?.role_permissions) ? 'disabled' : ''}`}
											onClick={() => exportData(`product`)}
										>
											Export Product
										</a>
									</li>
									<hr />
									<li>
										<a className="dropdown-item">Prefrence</a>
									</li>
									<li>
										<a
											className="dropdown-item"
											onClick={() => {
												dispatch(clearAdvanceFilter());
												setHeaderDropDown('All Products');
												setParams({
													page: 1,
													pageSize: 20,
													filters: {},
													sortBy: 'desc',
													orderBy: 'created_at',
												});
											}}
										>
											Refresh
										</a>
									</li>
								</ul>
							</div>
						)}
					</div>
				</div>
			)}

			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 10,
					padding: '0px 10px',
				}}
			>
				{isAdvanceFilterApplied && (
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						{selectedInputs.map((item) => (
							<AdvanceFilterSelectInput
								key={item.key}
								options={item?.data}
								placeholder={`Select ${item?.label}`}
								value={item?.value}
								disabled={false}
								onFocusCb={() => {
									handleOnFocusSelectedFilterInput(item?.key);
								}}
								onChange={(value) => {}}
								onSelect={(option) => {
									if (item?.key === 'status') {
										setHeaderDropDown(option?.value);
									}
									const updatedSelectedInput = selectedInputs.map((input) => {
										if (input.key === item?.key) {
											return {
												...input,
												value: option?.value,
											};
										}
										return input;
									});
									const params = getFiltersParams(updatedSelectedInput);
									dispatch(setSelectedInputValue({ key: item?.key, value: option.value }));
									handleApplyFilters(params);
								}}
								removeInput={() => {
									dispatch(removeSelectedInput({ key: item?.key }));
									const params = getFiltersParams(
										selectedInputs.filter((input) => input.key !== item?.key),
									);
									if (item.key === 'status') {
										setHeaderDropDown('All Products');
									}
									handleApplyFilters(params);
								}}
								className="selectInput"
							/>
						))}
						<div style={{ marginBottom: '8px', cursor: 'pointer' }}>
							<img
								src={addFilter}
								alt="Apply Filter"
								onClick={() => setIsAdvanceFilterOpen(true)}
							/>
						</div>
					</div>
				)}
			</div>

			{productId && bulkAction?.length === 0 && (
				<div className="add-group-detail px-4 mx-2 py-3 my-2">
					<div className="row">
						<div className="col-5">
							<InputField
								label="Group Name"
								placeholder="Enter Group Name"
								type="text"
								onChange={(val) => setgroupName(val)}
								value={groupName}
								error={error?.name}
							/>
						</div>
						<div class="col-3">
							<InputSelect
								label="Status"
								placeholder="Status"
								onChange={(value) => setgroupStatus(value)}
								value={groupStatus}
								options={status_dropdown || []}
								error={error?.status}
							/>
						</div>
					</div>
				</div>
			)}
			{loading ? (
				<div
					className="d-flex justify-content-center align-items-center"
					style={{ height: '100%', marginTop: '20%' }}
				>
					<span
						className="Page_loader"
						role="status"
						aria-hidden="true"
					></span>
				</div>
			) : (
				<Table
					row={tableData}
					className="productTable"
					coloum={ProductTableColumn}
					onRowDataChange={() => {}}
					bulkAction={bulkAction}
					onRowClick={onRowClick}
					style={isAdvanceFilterApplied ? { height: 'calc(100vh - 185px)' } : {}}
					action={setBulkAction}
				/>
			)}
			<Pagination
				currentPage={isAdvanceFilterApplied ? advanceFilterPage : currentPage}
				totalPages={isAdvanceFilterApplied ? advanceFilterTotalPages : totalPages}
				onChangePage={handlePageChange}
			/>
			{open && (
				<div>
					<Modal
						className="add-productgroup-modal"
						isOpen={open}
						onClose={() => setIsOpen(false)}
						title="Add to Group"
					>
						<AddToGroupModal
							isOpen={open}
							onCLose={() => setIsOpen(false)}
							reloadTable={getAllProduct}
							groupOption={groupOption}
							action={bulkAction}
						/>
					</Modal>
				</div>
			)}

			{buklImport && (
				<div>
					<Modal
						className="add-productgroup-modal"
						isOpen={buklImport}
						onClose={() => setIsbuklImport(false)}
						title=" Product bulk Import "
					>
						<BulkImport
							isOpen={buklImport}
							onClose={() => setIsbuklImport(false)}
							reloadTable={getAllProduct}
							type={'product'}
						/>
					</Modal>
				</div>
			)}
			{isAdvanceFilterOpen && (
				<AdvanceFilter
					modalLabel="Note: You can create a bill for either Yet to Receive Items or Received Items."
					isOpen={isAdvanceFilterOpen}
					advanceFilterOptions={advanceFilterOptions?.product}
					onFocusSelectedFilterInput={handleOnFocusSelectedFilterInput}
					handleOnChangeSelectedFilterInput={(key, value) => searchSelectedInputItems(key, value)}
					onClose={() => {
						setIsAdvanceFilterOpen(false);
					}}
					onApply={handleApplyFilters}
				/>
			)}
		</div>
	);
};

export default Product;
